import { Collapse } from '@subaio/components'

import { Container } from './Container'

type Props = {
	id: string
	hasError: boolean
	errorMessage?: string
}

export const InputError = ({ id, hasError, errorMessage }: Props) => (
	<Collapse isOpen={hasError} fill>
		<Container isVisible={hasError}>
			<span id={id} aria-hidden>
				{hasError && errorMessage}
			</span>
		</Container>
	</Collapse>
)
